import { selectedTasksData } from '@dyl/apiClients/backendApi';
import { useCallback } from 'react';
import useTasksDownload from './useTasksDownload';

export default function useExport() {
    const download = useTasksDownload();

    return useCallback(
        /**
         * @param {string[]} selectedIds
         */
        async function exportTasks(selectedIds) {
            let tasksToExport = {};

            if (selectedIds.length > 0) {
                tasksToExport = await selectedTasksData(selectedIds);
            }
            const toExport = tasksToExport;

            await download(toExport);

        }, [download]
    );
}